import { render, staticRenderFns } from "./infografia.vue?vue&type=template&id=9924eb0e&scoped=true&"
import script from "./infografia.vue?vue&type=script&lang=js&"
export * from "./infografia.vue?vue&type=script&lang=js&"
import style0 from "./infografia.vue?vue&type=style&index=0&id=9924eb0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9924eb0e",
  null
  
)

export default component.exports